import styled from '@emotion/styled';
import { Checkbox, FormControlLabel, DialogContent } from '@mui/material';
import { mq } from '@/utils/mediaQuery';

export const Container = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '6rem',

  padding: '8rem 1.6rem',
}));

export const InputForm = styled.form(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',

  maxWidth: '58rem',
}));

export const InputRows = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 0,
  flexDirection: 'column',

  '>*': {
    width: '100%',
    minHeight: '8rem',
  },

  [mq('tablet')]: {
    gap: '2.4rem 1.6rem',
    flexDirection: 'row',

    '>*': {
      width: '48%',
      minWidth: '48% !important',
    },
  },

  [mq('desktop')]: {
    gap: '2.4rem 1.6rem',
    flexDirection: 'row',

    '>*': {
      width: '48%',
    },
  },
}));

export const ButtonWrapper = styled.div(() => ({
  display: 'flex',
  justifyContent: 'center',
  height: '6rem',
  gap: '0 1.6rem',
  marginTop: '6rem',
}));

export const ButtonContent = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.6rem',
}));

/* -----------------------------------------------------
약관 - 웹사이트와 동일한 UI/UX를 사용하므로 동일한 이름 컨벤션(Signup~) 사용
----------------------------------------------------- */
export const SignupTermsBox = styled.div(() => ({
  backgroundColor: '#FBF6FE',
  padding: '1rem',
  borderRadius: '1rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '.4rem',
}));

export const SignupStyledFormControlLabel = styled(FormControlLabel)(() => ({
  alignItems: 'center',
  margin: 0,
}));

export const SignupStyledCheckbox = styled(Checkbox)(() => ({
  color: '#D6D6D6',
  padding: '0.4rem',
  marginRight: '0.4rem',
  '&.Mui-checked': {
    color: '#502875',
  },
  isolation: 'isolate',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '14px',
    height: '14px',
    backgroundColor: '#ffffff',
    zIndex: -1,
    borderRadius: '2px',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.8rem',
  },
}));

export const SignupTermsText = styled.div(({ isBold }) => ({
  fontSize: '12px',
  lineHeight: 1.3,
  fontWeight: isBold ? 700 : 400,
  [mq('tablet')]: {
    fontSize: '14px',
  },
}));

export const SignupTermHoverContainer = styled.div(({ theme }) => ({
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  '& .underline-target': {
    textDecoration: 'underline',
    color: theme.color.primary_color,
  },
}));

export const SignupStyledAllCheckbox = styled(Checkbox)(() => ({
  color: '#502875',
  padding: '0.4rem',
  marginRight: '0.4rem',
  '&.Mui-checked': {
    color: '#502875',
  },
  isolation: 'isolate',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '20px',
    height: '20px',
    backgroundColor: '#ffffff',
    zIndex: -1,
    borderRadius: '2px',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '2.4rem',
  },
}));

export const SignupTermsAllDivider = styled.div(({ theme }) => ({
  width: '100%',
  height: '1px',
  backgroundColor: '#E4E4E4',
  margin: '4px 0 12px 0',
}));

export const SignupTermsAllText = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  lineHeight: 1,
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#000',

  [mq('tablet')]: {
    fontSize: '16px',
  },
}));

export const SignupStyledDialogContent = styled(DialogContent)(() => ({
  minHeight: '400px',
}));
